import { Box, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  borderRadius: string;
  borderStyle: string;
}

const ViewSwitchButton = ({ isActive, onClick, icon, borderRadius, borderStyle }: IProps) => {
  const { sass: variables } = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        transition: 'all 0.3s',
        borderRadius,
        borderStyle,
        padding: '6px',
        backgroundColor: isActive ? variables.activeBackground : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      {icon}
    </Box>
  );
};

export default ViewSwitchButton;
